<template>
    <div class="page-wrapper">
        <div class="subject-details-wrapper">
            <div  class="subject-classify-wrapper">
                <div class="subject-classify" v-for="item in list" :key="item.id">
                    <div v-if="item.blockContainerItems && item.blockContainerItems.length" class="subject-classify-title clearfix">
                        <div class="title">{{item.name}}</div>
                        <div v-show="!isPhone && item.blockContainerItems && item.blockContainerItems.length > 8" class="seeMore pointer" @click="seeMore(item)">查看全部&nbsp;>&nbsp;
                        </div>
                        <div v-show="isPhone && item.hasMore" class="seeMore pointer" @click="seeMore(item)">查看全部
                            <img src="./../assets/img/wap_seeMore.png" alt="">
                        </div>
                    </div>
                    <div v-if="item.blockContainerItems && item.blockContainerItems.length">
                        <NewsList v-if="isPhone" :list="item.blockContainerItems.slice(0, 4)" />
                        <NewsList v-else :list="item.blockContainerItems.slice(0, 8)" :type="2" :subjectId="id" :skId="$Common.Base64.encode(item.id)" />
                    </div>
                </div>
            </div>
        </div>
        <GoHome v-if="isPhone" />
    </div>
</template>
<script>

import NewsList from '@/components/NewsList';
import GoHome from '@/components/GoHome.vue';
import { mapMutations } from 'vuex';
export default {
    name: 'SubjectDetail',
    data() {
        return {
            page: 1,
            id: null,
            sData: null,
            list: [],
            isLoading: false,
            errorImg: `this.parentNode.style.backgroundImage = 'url("${require('./../assets/img/default.png')}")'`, // 头图加载失败
        }
    },
    components: {
        NewsList,
        GoHome
    },
    created() {
        if(this.$route.params.id) {
            this.id = this.$route.params.id
        }
        this.getDetail();
    },
    mounted() {
        this.isPhone && this.$Common.onShare({
            shareTitle: '四川互联网举报辟谣平台',
            shareUrl: window.location.href
        })
    },
    watch: {
        $route(val) {
            if (val.params.id && this.id !== val.params.id) {
                this.setInit();
                this.id = val.params.id;
                this.getDetail();
            }
        }
    },
    methods: {
        ...mapMutations(['setLoadingShow']),
        setInit() {
            this.page = 1;
            this.list = [];
            this.isLoading = false;
        },
        getDetail() {
            const params = {
                
            }
            if(this.isPhone) {
                params.queryAllImg = true
                params.pageSize = 4
            }
            this.isLoading = true;
            this.$axios.post(this.$ApiInfo.getSubjectChannelList,params).then(res => {
                this.list = res.list
                this.list.forEach((item,index) =>{
                    if(item.blockContainerItems){
                        this.list[index].blockContainerItems = item.blockContainerItems.map(childItem => ({...childItem,images:{img169:childItem.imgUrl}}))
                    }else{
                        this.list[index].blockContainerItems = []
                    }
                    
                })
                this.setLoadingShow(false);
                this.isLoading = false;
            })
        },

        seeMore(item) { // 查看更多
            window.open(this.$router.resolve({
                path: `/subjectList/${this.$Common.Base64.encode(item.id)}`
            })['href'], '_blank');
        },

    },
    computed: {
        isPhone() {
            return this.$Common.Attribute.isMb();
        },

    },
}
</script>
<style lang="less" scoped>
.subject-details-wrapper {
    width: 100%;
    .subject-img-title {
        width: 100%;
        height: auto;
        margin-bottom: 1.5rem;
        .img {
            display: block;
            width: 100%;
            height: 12.75rem;
            background-repeat: no-repeat;
            background-position: center;
            background-size: cover;
            background-image: url('./../assets/img/default.png');
        }
        .text {
            padding: 1.25rem 1.5625rem;
            background: #fff;
            color: #333333;
            .title {
                font-size: 1.375rem;
                line-height: 1.875rem;
            }
            .brief {
                font-size: 1.25rem;
                line-height: 1.75rem;
            }
        }
    }
    .subject-classify-wrapper {
        .subject-classify {
            .subject-classify-title {
                color: #006df1;
                border-left: 0.1875rem solid #006df1;
                text-indent: .5em;
                margin-bottom: 0.875rem;
                line-height: 1.125rem;
                &.isSpecial{
                   color: #385C40;
                   border-left: 0.1875rem solid #385C40; 
                    .seeMore {
                        color: #385C40; 
                    }
                }
                .title {
                    float: left;
                }
                .seeMore {
                  font-size: 0.625rem;
                  color:#006DF1;
                  float: right;
                  img {
                    width: 0.3125rem;
                    height: 0.4375rem;
                  }
                }
            }
        }
    }
}

.wap-wrapper {
    .subject-details-wrapper {
        width: 100%;
        .subject-img-title {
            width: 100%;
            height: auto;
            margin-bottom: 5.333vw;
            position: relative;
            img {
                display: block;
                width: 100%;
                height: 100%;
            }
            .text {
                width: 100%;
                box-sizing: border-box;
                padding: 6.8vw 4vw 4.4vw;
                background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.8) 100%);
                color: #fff;
                position: absolute;
                bottom: 0;
                .title {
                    display: none;
                }
                .brief {
                    font-size: 4.533vw;
                    line-height: 6.4vw;
                }
            }
        }
        .subject-classify-wrapper {
            .subject-classify {
                .subject-classify-title {
                    color: #006df1;
                    margin-top: 3.067vw;
                    margin-bottom: 3.067vw;
                    line-height: 4.8vw;
                    font-size: 4.8vw;
                    padding: 0 4vw;
                    box-sizing: border-box;
                    border-left: none;
                    &.isSpecial{
                        color: #385C40;
                        padding-top:4.4vw;
                    }
                    .title {
                        border-left: 2px solid #006df1;
                        text-indent: .5em;
                        float: left;
                    }
                    &.isSpecial{
                        .title {
                           border-left: 2px solid #385C40; 
                        }
                    }
                    .seeMore {
                        font-size: 3.2vw;
                        line-height: 4.8vw;
                        float: right;
                        color:#666666;
                        img {
                            width: 1.6vw;
                            height: 2.667vw;
                        }
                    }
                }
            }
        }
    }
}
</style>